/* eslint-disable max-len */

import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: 'Press Release',
  toOverview: 'Return to overview'
})
